import React from 'react'
import styled from 'styled-components'

export default function ItemWithoutImg({name, price, options, text}) {
  return (
    <Container>
        <div className='name-holder'>
            <h4>{name}</h4>
            {options && <span>{text}</span>}
        </div>
        <p>{price}<span>rsd</span></p>
    </Container>
  )
}

const Container = styled.div`
    color: #fff;
    display: flex;
    width: 100%;
    max-width: 488px;
    justify-content: space-between;
    align-content: center;
    margin-bottom: 1.5rem;
    border-bottom: 1px dashed #fff;
    margin-left: auto;
    margin-right: auto;

    div.name-holder{
        display: flex;
        align-content: center; 
        flex-direction: column;

        h4{
            width: 70%;
            font-size: 1.3rem;     
            justify-self: flex-start;
        }
        span{
            width: 70%;
            font-size: 0.7rem;
            justify-self: flex-start;
        }
    }

    p{
        font-family: 'Roboto', sans-serif;
        font-size: 1.8rem;

        span{
            font-family: 'Epilogue';
            font-size: 0.8rem;
        }
    }
`
